import Badge from "../../../components/ui/Badge";
import {
  formatLearningHours,
  formatSeminarWhen,
  getSeminarState,
  PARTICIPANT_STATUS,
  selfCheckInView,
  SEMINAR_MODE,
  SEMINAR_TYPE_LABELS,
} from "../learningUtils";
import styles from "../Learning.module.css";

export const SkillChips = ({ skills = [] }) =>
  skills.length ? (
    <div className={styles.skillChips}>
      {skills.map((skill) => (
        <span
          key={skill.id}
          className={styles.skillChip}
          title={skill.category ?? undefined}
        >
          {skill.name}
        </span>
      ))}
    </div>
  ) : null;

// Card in a seminar list; the whole card opens the details.
const SeminarCard = ({ seminar, onOpen }) => {
  const state = getSeminarState(seminar);
  const mode = SEMINAR_MODE[seminar.mode];
  const my = seminar.my && PARTICIPANT_STATUS[seminar.my.status];

  return (
    <button
      type="button"
      className={styles.seminarCard}
      onClick={() => onOpen(seminar)}
    >
      <span className="d-flex flex-wrap gap-1">
        <Badge tone={state.tone}>{state.label}</Badge>
        {my && seminar.status !== "CANCELLED" && (
          <Badge tone={my.tone}>{my.label}</Badge>
        )}
        {selfCheckInView(seminar).kind === "button" && (
          <Badge tone="green" icon="bi-check2-circle">
            Check-in open
          </Badge>
        )}
        {seminar.seatsLeft != null && !seminar.my && (
          <Badge tone={seminar.seatsLeft > 0 ? "gray" : "red"}>
            {seminar.seatsLeft > 0 ? `${seminar.seatsLeft} seats left` : "Full"}
          </Badge>
        )}
      </span>

      <span className={styles.seminarTitle}>{seminar.title}</span>

      <span className={styles.seminarMeta}>
        <span>
          <i className="bi bi-calendar-event me-1"></i>
          {formatSeminarWhen(seminar.startAt, seminar.endAt)}
        </span>
        <span>
          {mode && <i className={`bi ${mode.icon} me-1`}></i>}
          {SEMINAR_TYPE_LABELS[seminar.type] ?? seminar.type} ·{" "}
          {mode?.label ?? seminar.mode}
          {seminar.hours != null && ` · ${formatLearningHours(seminar.hours)}`}
        </span>
        {seminar.venue && (
          <span>
            <i className="bi bi-pin-map me-1"></i>
            {seminar.venue}
          </span>
        )}
      </span>

      <SkillChips skills={seminar.skills} />
    </button>
  );
};

export default SeminarCard;
